import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FD0184",
      d: "M19.887 1.03a1 1 0 0 0-1.011-.99H9.781a1 1 0 0 0-1.01.99 1 1 0 0 0 1.01.989h8.084v7.914a1 1 0 0 0 1.011.99 1 1 0 0 0 1.01-.99zM2.256 18.7 19.59 1.729l-1.43-1.4L.827 17.3z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-up-2"}) } }